// actions
export const FETCH_DATA = 'data/FETCH_DATA'
export const FETCH_DATA_QUERY = 'data/FETCH_DATA_QUERY'
export const FETCH_DATA_CONTEXT_NETWORK = 'data/FETCH_DATA_CONTEXT_NETWORK'
// mutations
export const SET_FETCH_START = 'data/SET_FETCH_START'
export const SET_FETCH_DONE = 'data/SET_FETCH_DONE'
export const SET_FETCH_ERRORED = 'data/SET_FETCH_ERRORED'
